import { render, staticRenderFns } from "./ProfilePictureUpload.vue?vue&type=template&id=51a5c07a&scoped=true&"
import script from "./ProfilePictureUpload.vue?vue&type=script&lang=ts&"
export * from "./ProfilePictureUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePictureUpload.vue?vue&type=style&index=0&id=51a5c07a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5c07a",
  null
  
)

export default component.exports